import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  cardSkeleton: {
    backgroundColor: theme.palette.background.default,
    border: 'none',
    boxShadow: 'none',
    height: 'auto',
    padding: '10px',
    display: 'flex',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexDirection: 'column',
      alignItems: 'center'
    }
  },
  imgSkeleton: {
    width: '50%',
    borderRadius: '20px',
    aspectRatio: '16/9',
    height: '320px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 'auto'
    }
  },
  cardContentSkeleton: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  category: {
    width: '80px',
    alignItems: 'start'
  },
  cardContentItemSkeleton: {
    width: '100%'
  },
  moreRecentTextSkeleton: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  actionsSkeleton: {
    alignSelf: 'flex-end',
    width: 80,
    height: 20
  }
}))
